import { i18n } from 'app/utils/i18n';

const StepCarries = ({ preview }) => (
  <div className="roll-forward__step">
    <h4 className="roll-forward__heading">{i18n('roll-forward.step.carries')}</h4>
    <ul className="roll-forward__counts">
      <li>
        <strong>{preview.tagCount}</strong> {i18n('roll-forward.count.tags')}
      </li>
      <li>
        <strong>{preview.contexts.length}</strong> {i18n('roll-forward.count.contexts')}
      </li>
      <li>
        <strong>{preview.unitCount}</strong> {i18n('roll-forward.count.units')}
      </li>
    </ul>
    <p className="roll-forward__not-cloned text-gray-500">{i18n('roll-forward.not-cloned')}</p>
    <p className="roll-forward__reset-hint">
      <i className="fa-regular fa-circle-info mr-1" /> {i18n('roll-forward.reset-hint')}
    </p>
  </div>
);

export default StepCarries;
